<template>
  <v-layout class="main-wrapper" column>
    <v-app-bar class="header-bar" app fixed>
      <v-btn
        v-if="$vuetify.breakpoint.smAndDown"
        class="btn-icon ml-2"
        icon
        @click="drawer = !drawer"
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>

      <div v-else class="d-flex align-center">
        <v-img
          :src="require('@/assets/logo.png')"
          class="ml-16 mr-12"
          max-width="6rem"
          contain
        />

        <span
          v-for="(item, i) in _routes"
          :key="i"
          class="label"
          :class="{ 'label-active': isActive(item.path) }"
          @click="navigateTo(item)"
        >
          {{ item.label }}
        </span>
      </div>
    </v-app-bar>

    <v-navigation-drawer
      v-if="$vuetify.breakpoint.smAndDown"
      v-model="drawer"
      class="side-drawer rounded-r-xl"
      floating
      app
    >
      <div class="d-flex flex-column fill-height">
        <div class="d-flex align-center pa-4">
          <v-img
            :src="require('@/assets/logo.png')"
            class="mr-2"
            max-width="1.75rem"
            height="1.75rem"
            contain
          />

          <span class="text-h6 font-weight-bold">Hello Julio</span>
        </div>

        <v-list nav>
          <v-list-item
            v-for="(item, i) in _routes"
            :key="i"
            class="router-item"
            @click="navigateTo(item)"
          >
            <v-list-item-title :class="{ 'label-active': isActive(item.path) }">
              {{ item.label }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </div>
    </v-navigation-drawer>
  </v-layout>
</template>

<script>
export default {
  name: "NavBar",

  data() {
    return {
      drawer: false,
    };
  },

  computed: {
    _routes() {
      return [
        { label: "Sobre mim", path: "About", scrollTo: "#about-page-section" },
        {
          label: "Skills & Tools",
          path: "SkillsAndTools",
          scrollTo: "#skills-and-tools-page-section",
        },
        { label: "Carreira", path: "Career", scrollTo: "#career-page-section" },
        {
          label: "Contato",
          path: "Contact",
          scrollTo: "#contact-page-section",
        },
      ];
    },
    _options() {
      return {
        duration: 800,
        offset: 0,
        easing: "easeInQuad",
      };
    },
  },

  methods: {
    isActive(path) {
      return this.$route.name === path;
    },
    navigateTo(item) {
      this.$router.push({ name: item.path }).catch(() => {});
      this.$vuetify.goTo(item.scrollTo, this._options);
    },
  },
};
</script>

<style lang="scss" src="./style.scss" scoped />
